import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import GrinFloatingPopup from 'components/common/menu/GrinFloatingPopup'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'

const useStyles = makeStyles(theme => ({
  bodyContainer: {
    padding: 8
  }
}))

const PatientBriefFloatingPopup = ({
  title,
  isOpen,
  onCancel,
  onConfirm,
  anchorEl,
  children,
  description,
  isPrimaryBtnDisabled,
  className,
  // Optional label overrides; pass an empty string to hide a button entirely (GrinFloatingPopup
  // only renders a button when its label is non-empty).
  primaryBtnLabel,
  secondaryBtnLabel,
  // When both buttons are hidden the user needs another way out — opt into the close icon.
  withCloseIcon = false
}) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const resolvedPrimaryBtnLabel = primaryBtnLabel ?? t('general.confirm')
  const resolvedSecondaryBtnLabel = secondaryBtnLabel ?? t('general.cancel')

  return (
    <GrinFloatingPopup
      title={title}
      open={isOpen}
      onClose={onCancel}
      onOpen={() => {}}
      className={className}
      customAnchorEl={anchorEl}
      primaryBtnLabel={resolvedPrimaryBtnLabel}
      onPrimaryBtnClick={onConfirm}
      secondaryBtnLabel={resolvedSecondaryBtnLabel}
      onSecondaryBtnClick={onCancel}
      buttonProps={{ width: 145 }}
      withCloseIcon={withCloseIcon}
      isPrimaryBtnDisabled={isPrimaryBtnDisabled}
    >
      <div className={classes.bodyContainer}>
        {description && (
          <>
            <DazzedParagraph14 strong>{description}</DazzedParagraph14>
            <div style={{ height: 32 }} />
          </>
        )}
        {children}
      </div>
    </GrinFloatingPopup>
  )
}

export default PatientBriefFloatingPopup
